var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM3.5 7C3.5 7.15913 3.56321 7.31174 3.67574 7.42426C3.78826 7.53679 3.94087 7.6 4.1 7.6H9.9C10.0591 7.6 10.2117 7.53679 10.3243 7.42426C10.4368 7.31174 10.5 7.15913 10.5 7C10.5 6.84087 10.4368 6.68826 10.3243 6.57574C10.2117 6.46321 10.0591 6.4 9.9 6.4H4.1C4.02121 6.4 3.94319 6.41552 3.87039 6.44567C3.79759 6.47583 3.73145 6.52002 3.67574 6.57574C3.62002 6.63145 3.57583 6.69759 3.54567 6.77039C3.51552 6.84319 3.5 6.92121 3.5 7Z",
    fill: "#F05A28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSelection);
export default __webpack_public_path__ + "static/media/clear_selection.9a3c598d9fc262fa8853fd48be0d3923.svg";
export { ForwardRef as ReactComponent };